import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Tooltip,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

const StatCard = ({
  icon,
  label,
  value,
  change,
  trend,
  color = "primary",
  valueColor,
  description,
}) => {
  const colors = {
    primary: "#1E40AF",
    success: "#166534",
    warning: "#EA580C",
    error: "#991B1B",
    info: "#cffafe",
    purple: "#6B21A8",
  };

  return (
    <Tooltip title={description}>
      <Card
        sx={{
          height: "100%",
          transition: "transform 0.3s",
          boxShadow: "0px 1px 3px 0px #0000001A",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0px 4px 8px 0px #0000001A", // Optional: slightly stronger shadow on hover
          },
        }}
      >
        <CardContent>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: colors[color] || colors.primary,
              mb: 2,
            }}
          >
            {icon}
          </Avatar>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textTransform: "uppercase", fontWeight: 600 }}
          >
            {label}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, my: 1, color: valueColor || "text.primary" }}
          >
            {value}
          </Typography>
          {change && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {trend === "up" ? (
                <TrendingUpIcon sx={{ fontSize: 18, color: "success.main" }} />
              ) : (
                <TrendingDownIcon
                  sx={{ fontSize: 18, color: "success.main" }}
                />
              )}
              <Typography
                variant="caption"
                sx={{ fontWeight: 500, color: "success.main" }}
              >
                {change}
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </Tooltip>
  );
};

export default StatCard;
